import { Box, Flex, Stat, StatLabel, StatNumber, useColorModeValue } from "@chakra-ui/react";
import { ReactElement, ReactNode } from "react";

interface StatsCardProps {
    title: string;
    stat: string;
    icon: ReactNode;
}

const StatisticCard: React.FC<StatsCardProps> = ({ title, stat, icon }) => {
    return (
        <Stat
            px={{ base: 2, md: 4 }}
            py={'2'}
            shadow={'xl'}
            border={'1px solid'}
            borderColor={useColorModeValue('gray.300', 'gray.800')}
            rounded={'lg'}
        >
            <Flex justifyContent={'space-between'}>
                <Box pl={{ base: 2, md: 4 }} color={useColorModeValue('gray.300', 'gray.800')}>
                    <StatLabel fontSize={'xs'} fontWeight={'medium'} isTruncated>
                        {title}
                    </StatLabel>
                    <StatNumber fontSize={'large'} fontWeight={'medium'}>
                        {stat}
                    </StatNumber>
                </Box>
                <Box
                    my={'auto'}
                    color={useColorModeValue('gray.300', 'gray.800')}
                    alignContent={'center'}>
                    {icon}
                </Box>
            </Flex>
        </Stat>
    );
}

export default StatisticCard;